import { useSortable } from '@dnd-kit/sortable';
import { Widget, WidgetRepository, isContainer } from '@framework/engine';
import clx from 'classnames';
import React from 'react';
import { sortingStrategyDirection } from '../utils/sortingStrategyDirection';
import { ContainerDroppableAreas } from './ContainerDroppableAreas';
import {
  ParentInfoWrapper,
  SortableParentWidgetRenderWrapper,
  TotalWrapper,
} from './SortableParentWidgetRender.styled';
import { WidgetPreviewRenderWrapper } from './WidgetPreviewRenderWrapper.styled';

export interface ISortableParentWidgetRenderProps {
  widget: Widget;
  parent?: Widget;
  isSpaceForDrag?: boolean;
  isDragOverlay?: boolean;
  // l'utente sta spostano un widget (dragging)
  isMoving?: boolean;

  children?: React.ReactNode;

  compact?: boolean;
}

/**
 * Elemento container per la visualizzazione di un Elemento durante la configurazione.
 * Include un pulsante per l'apertura della modal di configurazione.
 * e le funzionalità per l'ordinamento tramite drag and drop.
 */
export function SortableParentWidgetRender(
  props: ISortableParentWidgetRenderProps,
) {
  const { widget, parent, compact } = props;
  const { isOver: overMe } = useSortable({ id: props.widget.id });

  const hasChildrenContainer =
    isContainer(widget) && widget.children?.some(isContainer);
  const hasParentContainer = isContainer(parent);

  // Nome del Widget
  const widgetName = WidgetRepository.find(widget.type)?.name;

  return (
    <TotalWrapper className={clx(`${sortingStrategyDirection(parent)}`)}>
      <ContainerDroppableAreas widget={widget} parent={parent}>
        <SortableParentWidgetRenderWrapper
          className={clx('sortable-parent-widget-render-wrapper', {
            'has-parent-container': hasParentContainer,
            'is-over-me': overMe,
            'is-space-for-drag': props.isSpaceForDrag,
            'is-drag-overlay': props.isDragOverlay,
          })}
        >
          <ParentInfoWrapper
            className={clx(
              // 'parent-info-wrapper',
              `${sortingStrategyDirection(widget)}`,
              {
                'has-children-container': hasChildrenContainer,
                'is-over-me': overMe,
                'is-space-for-drag': props.isSpaceForDrag,
              },
            )}
          >
            {widgetName || 'Container'}
            {overMe ? ' | sposta nell’elemento' : null}
          </ParentInfoWrapper>
          <WidgetPreviewRenderWrapper className={clx({ compact })}>
            {props.children}
          </WidgetPreviewRenderWrapper>

          {/* <div>{props.children}</div> */}
        </SortableParentWidgetRenderWrapper>
      </ContainerDroppableAreas>
    </TotalWrapper>
  );
}
